/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de salidas.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
*      2       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Cabecero, totales y modal de articulos portatiles
*      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Oculta carga manual en lector portatil
* ---------------------------------------------------------------------------------------
*/

import FrmSalidasAlmacenesExhibidores from "../../inventarios/FrmSalidasAlmacenesExhibidores.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";
import ModalBuscarArticulosParaVentaPortatil from "../modales/ModalBuscarArticulosParaVentaPortatil.jsx";

export default function FrmSalidasAlmacenesExhibidoresPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmSalidasAlmacenesExhibidores">
      <FrmSalidasAlmacenesExhibidores
        ModalBuscarArticulosComponent={ModalBuscarArticulosParaVentaPortatil}
        statusBotonCargaLector={false}
      />
    </SizeSoftXFrmPortatil>
  );
}
